import Splide from '@splidejs/splide';


if (document.querySelector('.splide')) {
  const reviewsSlider = new Splide('.splide', {
    perPage: 3,
    perMove: 1,
    gap: 24,
    pagination: true,
    arrows: false,
    breakpoints: {
      1280: {
        perPage: 2,
        gap: 24,
      },
      768: {
        perPage: 1,
        gap: 0,
      },
    },
  });

  reviewsSlider.mount();
}
